export default __webpack_public_path__ + "static/media/bike-friendly-accommodation.fd1afb7d.svg";